module.exports = __webpack_public_path__ + "static/img/album2.59f93c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/familybenefits/album2.png
// module id = fPvB
// module chunks = 1